import { OFFER_KIND } from '../../../../../../views/menu/offers/constants';

export default {
  [OFFER_KIND.PERCENTAGE_OFF_BY_PRODUCTS]: '{{percentage}}% de descuento en artículos seleccionados',
  [OFFER_KIND.PERCENTAGE_OFF_BY_MIN_SPEND_VALUE]: '{{percentage}}% de descuento en el valor total del pedido',
  [OFFER_KIND.FREE_ITEM_BY_PRODUCTS]: 'Artículo gratis con un artículo',
  [OFFER_KIND.FREE_ITEM_BY_MIN_SPEND_VALUE]: 'Artículo gratis con un valor de pedido',
  [OFFER_KIND.BOGO_HALF_PRICE]: 'Compra uno y llévate otro a mitad de precio',
  [OFFER_KIND.BOGO]: 'Compra uno y llévate otro gratis',
  [OFFER_KIND.AMOUNT_OFF_BY_PRODUCTS]: '{{amount}} de descuento en artículos seleccionados',
  [OFFER_KIND.AMOUNT_OFF_BY_MIN_SPEND_VALUE]: '{{amount}} de descuento con un valor de pedido',
};
